/* eslint-disable no-plusplus */
import * as React from 'react'
import Script from 'next/script'
import { useRouter } from 'next/router'
import { useUser } from 'api'

const Ebbot = () => {
  const { isAuthenticated, initiated, onEbbotInit } = useUser()

  const [init, setInit] = React.useState(false)
  const [isEbbotAvailable, setIsEbbotAvailable] = React.useState(false)

  const router = useRouter()

  React.useEffect(() => {
    if (router && Object.keys(router?.query).includes('ebbot')) {
      if (init && window.Ebbot) {
        setTimeout(() => {
          window.Ebbot.openChatWindow()
        }, 2000)
      }
    }
  }, [init, router])

  React.useEffect(() => {
    if (window.Ebbot) {
      if (!isAuthenticated && initiated) {
        setInit(true)
      }
    }
  }, [initiated, isAuthenticated])

  React.useEffect(() => {
    if (window && window.Ebbot) {
      window.Ebbot.onReset = () => {
        onEbbotInit()
      }

      window.Ebbot.onLoad = () => {
        onEbbotInit()
      }
    }
  }, [onEbbotInit])

  React.useEffect(() => {
    const checkAvailability = () => {
      if (
        typeof window !== 'undefined' &&
        window.Ebbot &&
        typeof window.Ebbot.show === 'function'
      ) {
        setIsEbbotAvailable(true)
      }
    }

    let intervalId = null

    if (init && !isEbbotAvailable) {
      intervalId = setInterval(() => {
        checkAvailability()
      }, 300)
    }

    return () => {
      if (intervalId) clearInterval(intervalId)
    }
  }, [init, isEbbotAvailable])

  const currentPath = router?.asPath?.trim()

  React.useEffect(() => {
    if (!isEbbotAvailable) return

    const disableEbbotPaths = [
      '/products/for-immune-health-family-edition-campaign',
      '/products/for-immune-health-family-edition',
      '/products/for-relief',
      '/products/hormones-and-me',
    ]

    if (isEbbotAvailable) {
      if (disableEbbotPaths.includes(currentPath)) window.Ebbot.hide()
      else window.Ebbot.show()
    }
  }, [currentPath, isEbbotAvailable])

  return (
    <>
      <Script id="ebbot">
        {`window.Ebbot = {
        botId: 'ebui29x9ks73q9pijojc9ovf9qbrp2', 
        ovh: false,
        fallback: false
      };`}
      </Script>
      <Script id="ebbot-ai">
        {`!function(t){var e="init-js-widget";if(!t.getElementById(e)){var i=t.createElement("script");i.id=e,i.src="https://ebbot-v2.storage.googleapis.com/ebbot-web/init.js?t="+Math.random(),t.querySelector("body").appendChild(i)}}(document);`}
      </Script>
      <Script id="ebbot-functions">
        {`function openLoginDialog(){var id="app-login-dialog";var e = document.getElementById(id);if(e){e.click();}}
        function openMyWallet(){window.location.href = "/account/wallet"}`}
      </Script>
    </>
  )
}

Ebbot.uiName = 'Ebbot'

export default Ebbot
